module.exports = __webpack_public_path__ + "static/media/S3N6-4.944ffec8.svg";